"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _reactRedux = require("react-redux");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var RenderInBody =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RenderInBody, _Component);

  function RenderInBody() {
    (0, _classCallCheck2.default)(this, RenderInBody);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RenderInBody).apply(this, arguments));
  }

  (0, _createClass2.default)(RenderInBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var className = this.props.className;
      this._container = document.createElement('div');

      if (className) {
        _dom.default.addClass(this._container, className);
      }

      document.body.appendChild(this._container);

      this._renderLayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _reactDom.unmountComponentAtNode)(this._container);
      document.body.removeChild(this._container);
    }
  }, {
    key: "_renderLayer",
    value: function _renderLayer() {
      var _this$props = this.props,
          store = _this$props.store,
          children = _this$props.children;

      if (store) {
        (0, _reactDom.render)(_react.default.createElement(_reactRedux.Provider, {
          store: store
        }, children), this._container);
      } else {
        (0, _reactDom.render)(children, this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return RenderInBody;
}(_react.Component);

exports.default = RenderInBody;
(0, _defineProperty2.default)(RenderInBody, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The element(s) to render. */
  children: _propTypes.default.element.isRequired,

  /** When using Redux, allows to pass the store down to the children so they have access to its data. */
  store: _propTypes.default.object
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RenderInBody, "RenderInBody", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/RenderInBody/RenderInBody.jsx");
  leaveModule(module);
})();

;